import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CaseManagementIncidentTypeComponent } from './case-management-incident-type.component';

const routes: Routes = [{ path: '', component: CaseManagementIncidentTypeComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CaseManagementIncidentTypeRoutingModule { }
